const queryUsuarioVistaModulosByEmail = `$filter=UsuarioCreacion eq '{EMAIL}' and CodigoModulo eq 'ReservaCentralizada'&$orderby=UsuarioVistaModuloId desc`

export const getQueryUsuarioVistaModulosByEmail = (email: string): string => {
  return queryUsuarioVistaModulosByEmail.replace('{EMAIL}', email)
}
